import { connect } from 'react-redux'
import {
  setMobileFilterButtonState,
} from 'Modules/searchPage/actions'
import FilterSaveSearchBar from './FilterSaveSearchBar'

const mapStateToProps = state => ({
  filterButtonActive: state.searchPage.filterButtonActive,
  filterLookup: state.searchFilters.filterLookup,
  filterOrders: state.searchFilters.filterOrders,
  basicFilterKeys: state.searchFilters.basicFilterKeys,
  specialFilterKeys: state.searchFilters.specialFilterKeys,
})
const actions = {
  setMobileFilterButtonState,
}
export default connect(
  mapStateToProps,
  actions,
)(FilterSaveSearchBar)
